import axios from "axios";
import util from "@/libs/util";

export function downLoading(res , type) {
    const disposition = res.headers["content-disposition"];
    const fileName = decodeURI(disposition);
    let url = window.URL.createObjectURL(
        new Blob([res.data], { type: type })
    );
    let a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.setAttribute("download", fileName);
    document.body.appendChild(a);
    a.click();
    url = window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
}



export function uploadSingleFile(data, token , url , time) {
    return axios({
      url: process.env.VUE_APP_API + url,
      method: "post",
      dataType: "json",
      responseType: "application/json",
      data: data,
      headers: {
        authorization: "Bearer " + token,
      },
      timeout : time
    });
  }